// web/pages/AiFans/AgeVerificationModal.tsx
import { Component, onMount, Show } from 'solid-js'
import FormModal from '/web/shared/FormModal'
import { userStore } from '/web/store'

const AGE_VERIFICATION_KEY = 'age_verification_accepted'

const AgeVerificationModal: Component = () => {
  const state = userStore()

  onMount(() => {
    // Check localStorage when component mounts
    const hasVerified = localStorage.getItem(AGE_VERIFICATION_KEY)
    if (hasVerified === 'true') {
      userStore.ageVerificationModal(false)
    }
  })

  const handleAccept = () => {
    // Save to localStorage and close modal
    localStorage.setItem(AGE_VERIFICATION_KEY, 'true')
    userStore.ageVerificationModal(false)
  }

  return (
    <Show when={state.showAgeVerification}>
      <div class="fixed bottom-0 left-0 right-0 top-0 z-[200] flex h-screen items-center justify-center overflow-y-auto overflow-x-hidden bg-black/70">
        <div
          onClick={(e) => e.stopPropagation()}
          class=" m-5 w-full rounded-[12px] border-[1px] border-white bg-black pb-4 pt-6 backdrop-blur md:w-[688px] md:pb-8 md:pt-14"
        >
          <div class="font-clash">
            <div class="flex flex-col gap-6">
              <div class="mx-2 flex flex-row items-center justify-center gap-2">
                <div class="mb-6 text-4xl md:text-[64px]">18+</div>
                <div class="text-center text-lg font-semibold md:mr-16 md:text-xl">
                  THE SITE CONTAINS SEXUALLY <br /> EXPLICIT MATERIAL
                </div>
              </div>
              <div class="flex justify-center">
                <button
                  onClick={handleAccept}
                  class="rounded-lg border-[0.5px] border-white bg-gradient-to-r from-cosplay-purple to-cosplay-blue-200 px-10 py-3 text-[22px] font-bold"
                >
                  I Agree
                </button>
              </div>

              <div class="mb-1 px-4 text-center text-[16px]">
                Enter ONLY if you are over 18. By using the site I accept the{' '}
                <a class="text-cosplay-purple hover:text-white" href="/privacy-policy">
                  Privacy Policy
                </a>{' '}
                and{' '}
                <a class="text-cosplay-purple hover:text-white" href="/terms-of-use">
                  Terms and Conditions
                </a>
                .
              </div>

              <div class="flex justify-center">
                <a
                  href="https://google.com"
                  class="text-center text-[18px] text-cosplay-purple transition-colors hover:text-white"
                >
                  No, I'll leave
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Show>
  )
}

export default AgeVerificationModal
